export default __webpack_public_path__ + "static/media/eye-green.fe3834d3.svg";